import { Settings } from "./settings";
import { AutosCoordinates } from "./autosCoordinates";

export const STATE = "USER";

export interface State {
  settings: Settings;
  autosCoordinates: AutosCoordinates;
}